export enum IconId {
  contract = 'contract',
  purchaseRequisition = 'purchaseRequisition',
  negotiationCase = 'negotiationCase',
  supplier = 'supplier',
  order = 'order',
  commodity = 'commodity',
  demand = 'demand',
  demandRequestItem = 'demandRequestItem',
  deliveryDate = 'deliveryDate',
  Speed = 'Speed',
  AccountBalance = 'AccountBalance',
  Widgets = 'Widgets',
  Person = 'Person',
  PeopleOutlined = 'PeopleOutlined',
  HandshakeOutlined = 'HandshakeOutlined',
  Subject = 'Subject',
  InsertDriveFileOutlined = 'InsertDriveFileOutlined',
  Business = 'Business',
  LinearScale = 'LinearScale',
  ErrorOutline = 'ErrorOutline',
  Percent = 'Percent',
  FilterTiltShiftOutlined = 'FilterTiltShiftOutlined',
  PaymentsOutlined = 'PaymentsOutlined',
  sourcingProjectAwarding = 'sourcingProjectAwarding',
  sourcingProjectItem = 'sourcingProjectItem',
}

export type IconIdUnion = keyof typeof IconId;
